import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_vm._t("header",function(){return [_c('base-header')]}),_c(VContent,{staticClass:"grey lighten-5"},[_c(VContainer,{staticClass:"base__container"},[_vm._t("sub-header",function(){return [_c('title-bar')]}),_vm._t("container",function(){return [_c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_vm._t("content")],2)],1)],1)]})],2)],1),_vm._t("footer",function(){return [_c('base-footer')]}),_vm._t("alert-bag",function(){return [_c('alert-bag',{attrs:{"alerts":_vm.findAll}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }